import React, { useState, useRef, useEffect } from "react";
import style from "./style.module.css";
import { useNavigate } from "react-router-dom";

function Slider({ images }) {
  const navigate = useNavigate();
  const containerRef = useRef();
  const [containerWidth, setContainerWidth] = useState(0);
  const [current, setCurrent] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStartX, setDragStartX] = useState(null);
  const [dragOffset, setDragOffset] = useState(0);
  const dragThreshold = 5; // minimum pixels to consider it a drag

  useEffect(() => {
    function updateWidth() {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    }
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  const onDragStart = (e) => {
    setIsDragging(false);
    setDragStartX(e.type === "touchstart" ? e.touches[0].clientX : e.clientX);
  };

  const onDragMove = (e) => {
    if (dragStartX === null) return;
    const currentX = e.type === "touchmove" ? e.touches[0].clientX : e.clientX;
    const offsetX = currentX - dragStartX;
    if (Math.abs(offsetX) > dragThreshold) {
      setIsDragging(true);
    }
    if (isDragging) {
      setDragOffset(offsetX);
    }
  };

  const onDragEnd = () => {
    if (!isDragging) return;
    if (dragOffset > containerWidth / 4) {
      setCurrent(current === 0 ? images.length - 1 : current - 1);
    } else if (dragOffset < -containerWidth / 4) {
      setCurrent((current + 1) % images.length);
    }
    setDragOffset(0);
    setIsDragging(false);
    setDragStartX(null);
  };

  const handleImageClick = () => {
    if (!isDragging) {
      setDragOffset(0);
      setIsDragging(false);
      setDragStartX(null);

      const slide = images[current];

      // Navigate to the constructed path
      navigate({
        pathname: "/search",
        search: `?q=${encodeURIComponent(slide.item_link_id)}&d=${encodeURIComponent(
          slide.item_title
        )}&linked=true`
      });
    }
  };

  const slideStyle = {
    display: "flex",
    width: containerWidth * images.length,
    transform: `translateX(${dragOffset - current * containerWidth}px)`,
    transition: isDragging ? "none" : "transform 0.3s ease-out",
  };

  return (
    <div className={style.carouselView}>
      <div
        ref={containerRef}
        style={{ overflow: "hidden", width: "100%", touchAction: "pan-y", userSelect: "none" }}
        onMouseDown={onDragStart}
        onMouseMove={onDragMove}
        onMouseUp={() => { onDragEnd(); handleImageClick(); }}
        onMouseLeave={onDragEnd}
        onTouchStart={onDragStart}
        onTouchMove={onDragMove}
        onTouchEnd={() => { onDragEnd(); handleImageClick(); }}
      >
        <div style={slideStyle}>
          {images.map((src, index) => (
            <img
              key={index}
              src={src}
              alt=""
              draggable={false}
              style={{ width: `${containerWidth}px`, height: "auto", flexShrink: 0 }}
              className={style.contentsView}
            />
          ))}
        </div>
      </div>

      <div className={style.controllerView}>
        <div className={style.indicator}>
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrent(index)}
              className={`${style.bullet} ${current === index ? style.active : ""}`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
        <div className={style.buttons}>
          <button className={`${style.button} ${style.prev}`} onClick={() => setCurrent(current === 0 ? images.length - 1 : current - 1)}>
            <span className="material-symbols-outlined">arrow_back_ios_new</span>
          </button>
          <button className={`${style.button} ${style.next}`} onClick={() => setCurrent((current + 1) % images.length)}>
            <span className="material-symbols-outlined">arrow_forward_ios</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Slider;